import * as React from 'react';
import { FormGroup, Label } from './styles/common';
import { Paragraph } from './FormInputDate.styles';

export function FormInputDate({
  label, paragraph, registration, valid, error, minDate, maxDate, value, onChange,
  // Optional note under the field. Marks a value filled in from an uploaded document,
  // so the user knows to check it rather than assume we got it right.
  // See FormInputText: marks a value that came from an uploaded document.
  hint,
}) {
  if (registration === undefined) {
    const handleChange = (e) => {
      onChange(e.target.value);
    };

    return (
      <FormGroup>
        {label !== undefined
                    && <Label>{label}</Label>}
        {paragraph !== undefined
                    && <Paragraph>{paragraph}</Paragraph>}
        <input className={`form-control text-center date ${error ? 'is-invalid' : ''} ${valid ? 'is-valid' : ''}`} type="date" lang="it-IT" min={minDate} max={maxDate} value={value} onChange={handleChange} />
        <div className="invalid-feedback">
          {error}
        </div>
        {hint && <p className="form-input-hint">{hint}</p>}
      </FormGroup>
    );
  }
  return (
    <FormGroup>
      {label !== undefined
                && <Label>{label}</Label>}
      {paragraph !== undefined
                && <Paragraph>{paragraph}</Paragraph>}
      <input className={`form-control text-center date ${error ? 'is-invalid' : ''} ${valid ? 'is-valid' : ''}`} type="date" lang="it-IT" min={minDate} max={maxDate} {...registration} />
      <div className="invalid-feedback">
        {error}
      </div>
      {hint && <p className="form-input-hint">{hint}</p>}
    </FormGroup>
  );
}
